<script setup lang="ts">
import { useUiStore } from '@/stores/ui'
import AppIcon from './AppIcon.vue'

const ui = useUiStore()
const icons = { success: 'check-circle', error: 'warning', warning: 'warning', info: 'info' } as const
</script>

<template>
  <Teleport to="body">
    <div class="toast-stack" role="region" aria-label="操作反馈" aria-live="polite">
      <TransitionGroup name="toast">
        <div v-for="toast in ui.toasts" :key="toast.id" class="toast" :class="`toast--${toast.type}`" role="status">
          <span class="toast__icon"><AppIcon :name="icons[toast.type]" :size="16" /></span>
          <span class="toast__body">
            <span class="toast__title">{{ toast.title }}</span>
            <span v-if="toast.detail" class="toast__detail">{{ toast.detail }}</span>
          </span>
          <button class="toast__close" type="button" aria-label="关闭提示" @click="ui.dismissToast(toast.id)">
            <AppIcon name="close" :size="12" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
